const getPhoenixCalendarDay = (date) => {
  const dateParts = new Intl.DateTimeFormat("en-CA", {
    timeZone: process.env.REACT_APP_DASHBOARD_PHOENIX_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  const datePart = (type) =>
    dateParts.find((part) => part.type === type)?.value;

  return `${datePart("year")}-${datePart("month")}-${datePart("day")}`;
};

const toCalendarDayNumber = (dateValue) => {
  const dateOnly = String(dateValue ?? "").slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateOnly)) return null;

  const [year, month, day] = dateOnly.split("-").map(Number);
  const timestamp = Date.UTC(year, month - 1, day);
  const parsedDate = new Date(timestamp);

  if (
    parsedDate.getUTCFullYear() !== year ||
    parsedDate.getUTCMonth() !== month - 1 ||
    parsedDate.getUTCDate() !== day
  ) {
    return null;
  }

  return Math.floor(
    timestamp / Number(process.env.REACT_APP_DASHBOARD_MILLISECONDS_PER_DAY),
  );
};

export const isWorkshopVisibleOnDashboard = (section, now = new Date()) => {
  if (!section || section.status !== "Scheduled") return false;

  const startDay = toCalendarDayNumber(section.startDate);
  const endDay = toCalendarDayNumber(section.endDate);
  const today = toCalendarDayNumber(getPhoenixCalendarDay(now));
  const leadDays = Number(process.env.REACT_APP_DASHBOARD_WORKSHOP_LEAD_DAYS);
  const trailingDays = Number(
    process.env.REACT_APP_DASHBOARD_WORKSHOP_TRAILING_DAYS,
  );
  if (startDay === null || endDay === null) return false;

  return today >= startDay - leadDays && today <= endDay + trailingDays;
};
